const InputAmount = (props) => {
  const { updateValue, value, onblur, onchange, number, className, disabled, step, ...attribute } = props || {};

  function handleFocus(e) {
    const val = e.target.value;
    if (typeof updateValue === "function" &&
      (val === 0 || val === "0")
    ) {
      updateValue("");
      e.target.value = "";
    }
  }

  function handleBlur(e) {
    const val = e.target.value;
    if (typeof updateValue === "function" && val === "") {
      updateValue(0);
      e.target.value = "0";
    }
    if (typeof onblur === "function") {
      return onblur(e);
    }
  }

  function handleChange(e) {
    if (typeof onchange === "function") {
      return onchange(e);
    }
  }

  return (
    <input type={number ? "number" : "text"}
      name="amount"
      className={className}
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      disabled={disabled}
      step={step ? step : "1"}
      pattern="[0-9]*"
      min="0"
      {...attribute}
    />
  );
};

export default InputAmount;
